// @flow
import React, {Fragment} from 'react';
import {GridActionsCellItem} from "@mui/x-data-grid-premium";
import EditIcon from "@mui/icons-material/Edit";
import TrashIcon from "../../../../assets/images/icons/buttons/trashIcon";

type Props = {
    id: string,
    hideEditButton: boolean,
    handleEditRow: Function,
    handleDeleteRow: Function
};

const GridRowToolBar = (props: Props) => {
    const {handleEditRow, handleDeleteRow, id, hideEditButton} = props
    return (
        <Fragment>
            {!hideEditButton && (
                <GridActionsCellItem
                    icon={<EditIcon/>}
                    label="Edit"
                    className="textPrimary"
                    onClick={() => handleEditRow(id)}
                    color="highlight"
                />
            )}
            <GridActionsCellItem
                icon={<TrashIcon/>}
                label="Delete"
                onClick={() => handleDeleteRow(id)}
                color={"error"}
            />
            
        </Fragment>
    )
};

export default GridRowToolBar